<template>
  <div class="publishing-tab__not-found" v-if="!baselineOptions.length">
    Baseline not found
  </div>
  <div
    v-else
    class="publishing-tab"
    :class="{ 'publishing-tab__print': isStaticView }"
  >
    <div class="update-loader" v-if="isDataUpdating">
      <base-loader class="update-loader-ring"/>
    </div>
    <div class="publishing-tab__row">
      <base-select
        @change="publish($event)"
        placeholder="Publish"
        :selectStyle="{
          height: '50px !important',
        }"
        :propListItemStyle="{
          height: '50px !important',
          cursor: 'pointer',
        }"
        :titleStyle="{
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          height: 'fit-content',
          margin: 'auto 0',
          display: 'inline-block',
        }"
        class="publishing-tab__publish-select"
        :options="publishOptions"
        :headerStyle="{
          width: '220px',
          backgroundColor: '#ffffff',
          color: 'inherit',
        }"
      />
      <div
        class="kc__tab"
        id="export-tab-dropdown-container"
        v-tooltip.bottom-start="{content: 'Export', ...tooltipOptions}"
        @click="$refs.export.open()"
      >
        <base-select
          ref="export"
          id="export-tab-dropdown"
          :selectStyle="{
            height: '50px !important',
          }"
          :isHideArrow="true"
          :options="exportOptions"
          @change="exportData($event)"
          alignLeft
          :titleStyle="{
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            height: 'fit-content',
            margin: 'auto 0',
            display: 'inline-block',
          }"
          :headerStyle="{height: '50px !important', padding: '0 10px'}"
          :propListItemStyle="{
            height: '50px !important',
            cursor: 'pointer',
          }"
          showTopBorder
          :maxHeightList="500"
          :placeholderIcon="'download'"
          :borderLess="true"
          :placeholderStyle="{'font-size':'20px', 'color': '#011627', 'padding': '0px'}"
        />
      </div>
    </div>
    <div class="publishing-tab__row">
      <div class="publishing-tab__table">
        <div
          class="
            publishing-tab__table__row publishing-tab__table__row__baseline
          "
        >
          <div class="publishing-tab__table__cell">
            <span class="publishing-tab__span">Baseline</span>
          </div>
          <div
            class="
              publishing-tab__table__cell publishing-tab__table__cell__dropdown
            "
          >
            <base-select
              :options="baselineOptions"
              alignLeft
              borderLess
              v-model="computedBaselineId"
              :titleStyle="{ paddingRight: '33px' }"
              :selectStyle="{ height: '100%!important', marginLeft: '16px' }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="publishing-tab__row">
      <div class="publishing-tab__table">
        <div
          class="publishing-tab__table__row"
          v-for="(row, i) in tableContents"
          :key="i"
        >
          <div class="publishing-tab__table__cell">
            {{ row.title }}
          </div>
          <div class="publishing-tab__table__cell">
            {{ row.content }}
          </div>
          <div class="publishing-tab__table__cell">
            <base-material-design-icon
              icon="copy"
              v-tooltip.top-start="{ content: 'Copy', ...tooltipOptions }"
              @click="copyToClipboard(row.content)"
              class=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="publishing-tab__row">
      <div class="publishing-tab__table">
        <div class="publishing-tab__table__row">
          <div class="publishing-tab__table__cell">
            <span class="publishing-tab__span">Optimized Content</span>
          </div>
          <div class="publishing-tab__table__cell">
            <div>
              <base-radio
                v-model="contentViewType"
                style="margin-left: 20px"
                value="0"
                label="Rendered Text"
                class="radio-button"
                crossColor="#8F90A6"
              />
              <base-radio
                v-model="contentViewType"
                style="margin-left: 30px"
                value="1"
                label="Plain Text"
                class="radio-button"
                crossColor="#8F90A6"
              />
              <base-radio
                v-model="contentViewType"
                style="margin-left: 20px"
                value="2"
                label="Code"
                class="radio-button"
                crossColor="#8F90A6"
              />
            </div>
          </div>
          <div class="publishing-tab__table__cell">
            <base-material-design-icon
              icon="copy"
              v-tooltip.top-start="{ content: 'Copy', ...tooltipOptions }"
              @click="
                copyHtmlContentToClipboard(
                  displayedOptimizedContent,
                  contentViewType
                )
              "
              class=""
            />
          </div>
        </div>
        <div
          class="
            publishing-tab__table__row
            publishing-tab__table__row__full-width
            publishing-tab__table__row__content
          "
        >
          <div class="publishing-tab__table__cell">
            <div class="publishing-tab__content">
              <div v-show="contentViewType === '0'">
                <div ref="markup" v-html="displayedOptimizedContent"></div>
              </div>
              <div v-show="contentViewType === '1'">
                <pre>
									{{ contentPlainText }}
								</pre>
              </div>
              <div v-show="contentViewType === '2'">
                {{ displayedOptimizedContent }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="publishing-tab__row">
      <div class="publishing-tab__table">
        <div
          class="
            publishing-tab__table__row publishing-tab__table__row__images_header
          "
        >
          <div
            class="
              publishing-tab__table__cell publishing-tab__table__cell__no-border
            "
          >
            <span class="publishing-tab__span">Images</span>
          </div>
          <div class="publishing-tab__table__cell">
            <base-material-design-icon
              icon="plusCircle"
              v-if="!isAddNewAttachment"
              @click="addNewType = 'link'"
              v-tooltip.top-start="{ content: 'Add New', ...tooltipOptions }"
              class=""
            />
          </div>
        </div>
        <div class="publishing-tab__table__row__full-width">
          <div class="publishing-tab__table__cell">
            <Attachments
              :attachments="publishingAttachments"
              :isAddNewAttachment="isAddNewAttachment"
              :briefId="briefId"
              :isPublishTab="true"
              :addNewType="addNewType"
              @addNewChange="changeAddNew"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="publishing-tab__row">
      <div class="publishing-tab__table">
        <div
          class="
            publishing-tab__table__row publishing-tab__table__row__images_header
          "
        >
          <div
            class="
              publishing-tab__table__cell publishing-tab__table__cell__no-border
            "
          >
            <span class="publishing-tab__span">Properties</span>
          </div>
          <div class="publishing-tab__table__cell">
            <base-material-design-icon
              icon="plusCircle"
              @click="addKeyFieldRow"
              v-tooltip.top-start="{ content: 'Add Row', ...tooltipOptions }"
              class=""
            />
          </div>
        </div>
        <div
          v-for="(row, i) in keyFields"
          :key="row.key_id"
          class="
            publishing-tab__table__row publishing-tab__table__row__key-fields
          "
        >
          <div class="publishing-tab__table__cell__input">
            <input
              placeholder="key name"
              borderless
              @input="
                () => {
                  keyFields[i].key_name = keyFields[i].key_name
                    .trim()
                    .replace(/\s+/g, '-')
                    .replace(/_+/g, '-')
                  saveKeyFields(keyFields[i])
                }
              "
              v-model="keyFields[i].key_name"
            />
          </div>
          <div class="publishing-tab__table__cell__input">
            <input
              placeholder="Key Value"
              borderLess
              @input="saveKeyFields(keyFields[i])"
              v-model="keyFields[i].key_value"
            />
          </div>
          <div class="publishing-tab__table__cell">
            <base-material-design-icon
              icon="close"
              @click="removeKeyFieldRow(i)"
              v-tooltip.top-start="{ content: 'Remove Row', ...tooltipOptions }"
              class=""
            />
          </div>
        </div>
      </div>
    </div>
    <div class="publishing-tab__row">
      <div class="publishing-tab__table">
        <div class="publishing-tab__table__row publishing-tab__table__row__log">
          <div v-for="(col, i) in logTableColumns" :key="i" class="publishing-tab__table__cell">
            <span class="publishing-tab__log-span">{{ col.label }}</span>
          </div>
        </div>
        <div
        v-for="(row, i) in briefContent.publish_log"
        :key="i"
        class="publishing-tab__table__row publishing-tab__table__row__log">
          <div v-for="(col, i) in logTableColumns" :key="i" class="publishing-tab__table__cell">
            <span v-if="col.value === 'publish_queue_id' && row.has_content">
              <base-material-design-icon icon="download" @click="exportHistoricData(row)" />
            </span>
            <span v-else-if="col.value !== 'publish_queue_id'">
              {{ row[col.value] }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <modal name="confirm-modal" v-bind="modalProps">
      <base-confirm-modal
        :title="`Are you sure you want to ${isUnpublish ? 'UNPUBLISH' : 'publish'} this (${publishMethodsMap[publishMethod]})?`"
        :subtitle="isUnpublish ? 'This will remove the published page' : ''"
        :yesBtnColor="isUnpublish ? '#e11c21' : '#2f404e'"
        @confirm="confirmPublish"
      />
    </modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */

import { mapActions, mapState } from 'vuex'
import ContentBrief from './index'
import Attachments from './Attachments'
import baseModalProps from '@/common/BaseModalProps'
import _ from 'lodash'
import ToasterService from '@/services/toasterService'
import moment from 'moment'
import papaparse from 'papaparse'

const SELECT_OPTIONS = [
  {
    label: 'Link',
    value: 'link'
  },
  {
    label: 'File',
    value: 'file'
  }
]

const LOG_TABLE_COLUMNS = [
  {
    label: 'Status',
    value: 'status'
  },
  {
    label: 'Publish Method',
    value: 'publish_method'
  },
  {
    label: 'Baseline',
    value: 'baseline_name'
  },
  {
    label: 'User',
    value: 'user_name'
  },
  {
    label: 'Timestamp Created',
    value: 'timestamp_created'
  },
  {
    label: 'Timestamp Failed',
    value: 'timestamp_failed'
  },
  {
    label: 'Timestamp Published',
    value: 'timestamp_published'
  },
  {
    label: 'Export',
    value: 'publish_queue_id'
  }
]
/**
 * Publishing tab. Used in {@link ContentBrief}
 */
export default {
  name: 'PublishingTab',

  props: {
    isStaticView: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isEditorOpened: false,
      link: document.location.href,
      sortedSnapshots: [],
      isDataUpdating: false,
      activeResizable: true,
      editorDrag: false,
      editorField: null,
      selectOptions: [...SELECT_OPTIONS],
      addNewType: '',
      isAttachmentsCollapsed: false,
      editorCollapsedState: false,
      contentViewType: '0',
      tooltipOptions: {
        delay: { show: 100, hide: 100 },
        classes: 'rfx-tooltip-arrow'
      },
      selectedBaselineId: '',
      hasMounted: false,
      contentPlainText: '',
      contentInnerHtml: '',
      keyFields: [],
      keyFieldCount: 1,
      publishMethod: null,
      isUnpublish: false,
      exportOptions: [
        {
          label: 'Export as CSV',
          value: 'csv'
        },
        {
          label: 'Export as JSON',
          value: 'json'
        }
      ],
      logTableColumns: LOG_TABLE_COLUMNS,
      publishMethodsMap: {
        'manual': 'API',
        'cloudflare': 'Cloudflare',
        'cloudflare-unpublish': 'Cloudflare - Unpublish',
        'webhook': 'Webhook'
      }
    }
  },
  components: {
    Attachments
  },
  computed: {
    ...mapState({
      isNavbarCollapsed: 'isNavbarCollapsed'
    }),
    ...mapState('rankZoneCommon', [
      'publishingEnabled',
      'shopifyEnabled',
      'webhookEndpointEnabled',
      'apiKeyEnabled',
      'cloudflareEnabled']),
    ...mapState('briefContent', ['briefContent']),
    ...mapState({
      userEmail: (state) => {
        return state.currentUser ? state.currentUser.email : ''
      },
      clients: 'clients',
      selectedClient: 'selectedClient'
    }),
    publishOptions () {
      const options = []
      if (this.apiKeyEnabled) {
        options.push(
          { label: this.publishMethodsMap['manual'], value: 'manual' }
        )
      }
      if (this.cloudflareEnabled && this.shopifyEnabled) {
        options.push(
          { label: this.publishMethodsMap['cloudflare'], value: 'cloudflare' },
          { label: this.publishMethodsMap['cloudflare-unpublish'], value: 'cloudflare-unpublish' }
        )
      }
      if (this.webhookEndpointEnabled) {
        options.push(
          { label: this.publishMethodsMap['webhook'], value: 'webhook' }
        )
      }
      return options
    },
    publishingAttachments () {
      return this.briefContent.attachements.filter(
        (img) => img[6].category === 'Publishing'
      )
    },
    isAddNewAttachment () {
      return this.addNewType !== ''
    },
    computedBaselineId: {
      get () {
        if (this.selectedBaselineId) {
          return this.selectedBaselineId
        }
        const currentlyPublishedBaselineId = this.briefContent?.baselines.find(baseline => baseline.is_published)?.id
        const lastCreatedBaselineId = this.briefContent?.baselines[0]?.id
        return currentlyPublishedBaselineId ?? lastCreatedBaselineId
      },
      set (newValue) {
        this.selectedBaselineId = newValue
        this.updateMarkupRef()
      }
    },
    selectedBaseline () {
      return this.briefContent.baselines.find(
        (baseline) => baseline.id === this.computedBaselineId
      )
    },
    baselineOptions () {
      return this.briefContent.baselines.map((baseline) => ({
        label: baseline.label,
        value: baseline.id
      }))
    },
    publishingImages () {
      return [
        {
          name: 'test',
          name_alt: 'alt',
          thumbnail: 'thumbnail',
          link: 'test.com'
        },
        {
          name: 'image name',
          name_alt: 'alt image name',
          thumbnail: 'thumbnail',
          link: 'test.com'
        }
      ]
    },
    displayedOptimizedContent() {
      let html = new DOMParser().parseFromString(this.selectedBaseline.content, 'text/html')
      let elements = html.getElementsByTagName("*")

      for (let i = 0; i < elements.length; i++) {
        elements[i].removeAttribute('style')
      }
      return html.body.innerHTML
    },
    tableContents () {
      return [
        {
          title: 'Full URL',
          content: this.briefContent.url
        },
        {
          title: 'URL Slug',
          content: this.briefContent.name
        },
        {
          title: 'SEO Title Tag',
          content: this.selectedBaseline.tag_title
        },
        {
          title: 'Meta Description',
          content: this.selectedBaseline.tag_meta_description
        },
        {
          title: 'Headline (H1)',
          content: this.getContentHeadline(this.selectedBaseline.content)
        }
      ]
    },
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    },
    briefId () {
      return this.$route.params.id
    },
    isKeywordsPresent () {
      return this.briefContent.keywords && this.briefContent.keywords.length
    },
    keywords () {
      return this.briefContent.keywords
    },
    attachmentsCount () {
      return (this.briefContent.attachements || []).length
    }
  },
  mounted () {
    this.contentPlainText = this.$refs['markup'].innerText
    this.contentInnerHtml = this.$refs['markup'].innerHTML
    this.loadProperties()
  },
  watch: {
    isAddNewAttachment (v) {
      v && (this.isAttachmentsCollapsed = false)
    }
    // briefContent: {
    //   handler () {
    //     this.loadProperties()
    //   },
    //   deep: true
    // }
  },
  methods: {
    ...mapActions('briefContent', [
      'getBriefContent',
      'getComments',
      'changeContentBrief',
      'patchPublishingProperties',
      'publishBrief',
      'getPublishingData',
      'getHistoricPublishingData'
    ]),
    async exportHistoricData (publishRecord) {
      this.isDataUpdating = true
      const data = await this.getHistoricPublishingData(publishRecord.publish_queue_id)
        .then(response => {
          response = JSON.stringify(response)
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(new Blob([response]))
          const baselineName = `${publishRecord.baseline_name}_${publishRecord.timestamp_created}`
          const fileName = `${baselineName}.json`
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
        }).catch(console.error)
      this.isDataUpdating = false
    },
    async exportData (fileType) {
      this.isDataUpdating = true
      const data = await this.getPublishingData(this.computedBaselineId)
        .then(response => {
          if (fileType === 'csv') {
            // Flatten properties and images for csv format
            for (const k in response.properties) {
              response[`property_${k}`] = response.properties[k]
            }
            delete response.properties
            response.images.forEach((img, i) => {
              response[`image_${i + 1}_link`] = img.image_link
              response[`image_${i + 1}_name`] = img.image_name
              response[`image_${i + 1}_name_alt`] = img.image_name_alt
            })
            delete response.images
            response = papaparse.unparse([response])
          } else {
            response = JSON.stringify(response)
          }
          const downloadUrl = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = downloadUrl
          const baselineName = this.briefContent.name
            .slice(1)
            .trim()
            .replace(/\//g, '_')
          const currentDate = moment().format('YYYYMMDD')
          const fileName = `${baselineName}_${currentDate}.${fileType}`
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
        }).catch(console.error)
      this.isDataUpdating = false
    },
    publish (method) {
      if (method === 'cloudflare-unpublish') {
        this.publishMethod = 'cloudflare'
        this.isUnpublish = true
      } else {
        this.publishMethod = method
        this.isUnpublish = false
      }
      this.$modal.show('confirm-modal')
    },
    async confirmPublish (val) {
      if (val) {
        this.isDataUpdating = true
        await this.publishBrief({
          briefId: this.briefId,
          versionId: this.computedBaselineId,
          method: this.publishMethod,
          unpublish: this.isUnpublish
        })
        this.isDataUpdating = false
      }
      this.getData()
      this.$modal.hide('confirm-modal')
    },
    loadProperties () {
      this.keyFields = this.briefContent.properties.map((prop) => {
        this.keyFieldCount += 1
        return {
          key_id: this.keyFieldCount,
          key_name: prop.key_name,
          key_value: prop.key_value,
          id: prop.id
        }
      })
      if (!this.keyFields.length) {
        this.addKeyFieldRow()
      }
    },
    addKeyFieldRow () {
      this.keyFieldCount += 1
      this.keyFields.push({
        key_id: this.keyFieldCount,
        key_name: '',
        key_value: '',
        id: null
      })
    },
    debouncedSaveKeyFields: _.debounce(async (row, scope) => {
      if (!row.key_name || !row.key_value) return
      scope.updateKeyFields({ data: row, isDelete: false })
    }, 750),
    saveKeyFields (row) {
      this.debouncedSaveKeyFields(row, this)
    },
    async updateKeyFields (rowData) {
      const res = await this.patchPublishingProperties({
        briefId: this.briefContent._id,
        data: JSON.stringify(rowData)
      })
      if (!rowData.isDelete) {
        this.keyFields.find((row) => row.key_id === rowData.data.key_id).id = res.data.id
      }
    },
    removeKeyFieldRow (idx) {
      let data = this.keyFields[idx]
      this.keyFields.splice(idx, 1)
      this.updateKeyFields({ data, isDelete: true })
    },
    updateMarkupRef () {
      this.$nextTick(() => {
        this.contentPlainText = this.$refs['markup'].innerText
        this.contentInnerHtml = this.$refs['markup'].innerHTML
      })
    },
    /**
     * get content brief data
     * used only after updating content brief
     */
    async getData () {
      try {
        await this.getBriefContent({
          briefId: this.briefContent._id,
          reset: false,
          clientId: this.clientId
        })
      } catch {
        this.$router.replace('/publishing/url-planner')
        return
      }
      this.getComments({ briefId: this.briefContent._id })
      this.loadProperties()
    },
    getContentHeadline (content) {
      return new DOMParser()
        .parseFromString(content, 'text/html')
        .getElementsByTagName('h1')[0]?.innerText
    },

    getPlainText (content) {
      let html = new DOMParser().parseFromString(content, 'text/html')
      return html.body.innerText
    },
    copyToClipboard (text) {
      this.$copyText(text).then((e) => {
        ToasterService.showToast(
          ToasterService.INFO_TYPE,
          'Copied to clipboard'
        )
      })
    },
    copyHtmlContentToClipboard (displayedOptimizedContent, contentType) {
      if (contentType === '0') {
        const blobInput = new Blob([this.contentInnerHtml], {
          type: 'text/html'
        })
        const clipboardItemInput = new ClipboardItem({
          'text/html': blobInput
        })
        navigator.clipboard.write([clipboardItemInput]).then((e) => {
          ToasterService.showToast(
            ToasterService.INFO_TYPE,
            'Copied to clipboard'
          )
        })
      } else if (contentType === '1') {
        this.copyToClipboard(this.contentPlainText)
      } else {
        this.copyToClipboard(displayedOptimizedContent)
      }
    },
    /**
     * opens content notes editor modal
     */
    openEditorModal (field) {
      if (this.isEditorOpened) {
        return
      }
      this.editorField = field
      this.isEditorOpened = true
      this.activeResizable = true
      // set initial state for editor
      this.$nextTick(() => {
        this.$refs.editor.$el.setAttribute(
          'style',
          `top:calc(100vh - ${
            this.$refs.editor.h / 2
          }px); left:130px; position:absolute; width: calc(100vw - 130px); height: 490px;`
        )
        this.$refs.editor.x = 130
        this.$refs.editor.y = this.$refs.editor.$el.offsetTop
        this.$refs.editor.w = this.$refs.editor.$el.offsetWidth
      })
      // // scrolls keyword cloud block at the top of visible area
      // setTimeout(() => {
      //   const element = this.$refs['keyword-cloud']
      //   element && element['$el'].scrollIntoView({ block: 'start', behavior: 'smooth' })
      // }, 1000)
    },
    tryCloseEditorModal (payload) {
      this.editorPayload = payload
      const initialPayload = this.$refs.contentNotesEditor.initialPayload
      if (!_.isEqual(initialPayload, payload)) {
        this.editorCollapsedState = this.$refs.contentNotesEditor.isCollapsed
        this.$refs.contentNotesEditor.isCollapsed = true
        this.changeCollapsed(true)
        this.$modal.show('confirm-modal')
      } else {
        this.closeEditorModal(true)
      }
    },
    closeEditorModal (status) {
      this.$modal.hide('confirm-modal')
      const initialPayload = this.$refs.contentNotesEditor.initialPayload
      const isEditorDirty = !_.isEqual(initialPayload, this.editorPayload)
      if (status) {
        isEditorDirty && this.onApplyEditor(this.editorPayload)
        this.editorDrag = false
        this.isEditorOpened = false
      } else {
        // this.$refs.contentNotesEditor.isCollapsed = this.editorCollapsedState
        // this.changeCollapsed(this.editorCollapsedState)
        this.editorDrag = false
        this.isEditorOpened = false
      }
    },
    updateContentBrief: async function (payload) {
      try {
        // this.isDataUpdating = true
        await this.changeContentBrief(payload)
        return true
        // await this.getData()
        // this.isDataUpdating = false
      } catch (e) {
        return false
        // this.isDataUpdating = false
      }
    },
    /**
     * callback inviked by updating content brief notes
     */
    async onApplyEditor (payload) {
      this.editorPayload = payload
      // this.closeEditorModal()
      const updated = await this.updateContentBrief(payload)
      if (updated) {
        this.$refs.contentNotesEditor.resetUndo()
      }
    },
    changeDragging (state) {
      this.editorDrag = state
    },
    changeAddNew (isUpdate) {
      this.addNewType = ''
      isUpdate && this.getData()
    },
    changeCollapsed (isCollapsed) {
      this.activeResizable = !isCollapsed
      if (isCollapsed) {
        // collapse and move to the bottom - right
        this.$refs.editor.$el.setAttribute(
          'style',
          `top:calc(100vh - 250px);
                                                     left:calc(100vw - 520px);
                                                     position:absolute;
                                                     width: 500px;
                                                     height: 250px;
                                                     transition-duration: 1s;`
        )
      } else {
        // return to previous state
        this.$refs.editor.$el.setAttribute(
          'style',
          `top:${this.$refs.editor.top}px;
                                                     left:${this.$refs.editor.left}px;
                                                     position:absolute;
                                                     width: ${this.$refs.editor.width}px;
                                                     height: ${this.$refs.editor.height}px;
                                                     pointer-events: none;
                                                     transition-duration: 1s;`
        )
        setTimeout(() => {
          // remove animation and enable drag-n-drop
          this.$refs.editor.$el.setAttribute(
            'style',
            `top:${this.$refs.editor.top}px;
                                                     left:${this.$refs.editor.left}px;
                                                     position:absolute;
                                                     width: ${this.$refs.editor.width}px;
                                                     height: ${this.$refs.editor.height}px;`
          )
        }, 1000)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.update-loader {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    background-color: white;
    top: 0;
    opacity: 0.5;
    z-index: 10000;
}
.update-loader-ring {
    margin-top: 200px;
}
pre {
  white-space: pre-wrap;
}
.radio-button {
  cursor: pointer;
}
.publishing-tab__publish-select {
  width: 220px;
  margin-left: auto;
}
.publishing-tab__table {
  break-inside: avoid;
  display: grid;
  width: 100%;
  // flex-direction: column;
  background-color: white;
  // margin-top: 1rem;
  border-radius: 4px;
  border: 1px solid rgba(1, 22, 39, 0.1);
  box-sizing: border-box;
  // position: relative;
  &__row {
    border-top: 1px solid $rfx-light-grey;
    // position: relative;
    display: grid;
    grid-template-columns: 2fr 8fr 1fr;
    // flex-direction: row;
    &:first-child {
      border: 0;
    }
    &__log {
      grid-template-columns: 1fr 1fr 1fr 1fr 2fr 2fr 2fr 1fr;
    }
    &__full-width {
      grid-template-columns: 1fr;
    }
    &__content {
      overflow-x: auto;
    }
    &__images_header {
      grid-template-columns: 10fr 1fr;
    }
    &__images {
      grid-template-columns: 3fr 3fr 4fr 1fr;
    }
    &__attachments_header {
      grid-template-columns: 2fr 9fr;
    }
    &__baseline {
      grid-template-columns: 2fr 9fr;
    }
    &__key-fields {
      grid-template-columns: 5fr 5fr 1fr;
    }
  }
  &__cell {
    border-right: 1px solid $rfx-light-grey;
    padding: 10px;
    padding-top: 20px;
    // position: relative;
    &:last-child {
      border: 0;
    }
    &__no-border {
      border: 0;
    }
    &__dropdown {
      padding: 0;
    }
    &__input {
      padding: 0;
    }
  }
}

.hide {
  display: none;
}

.highlight-msg-icon {
  color: $rfx-bright-turquoise;
}

.publishing-tab {
  &__add-new-attachment {
    display: flex;
    position: relative;

    .publishing-tab__edit-icon {
      // position: absolute;
      // left: -3px;
    }
  }

  &__span {
    font-size: 16px;
    font-weight: bold;
  }
  &__log-span {
    font-size: 14px;
    font-weight: bold;
  }

  &__content {
    width: 90%;
    margin: auto;
  }

  &__attachments-count {
    color: white;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #284aff;
    width: 20px;
    height: 20px;
    margin-right: auto;
  }

  &__row {
    margin-top: 10px;
    display: flex;

    &:first-child {
      margin-top: 0;
    }
  }

  &__keyword-cloud {
    flex: 1 1;
    margin-right: 16px;
  }

  &__attachments {
    //   flex: 0 0 37%;
    //   max-width: 37%;
  }

  &__edit {
    cursor: pointer;
    display: flex;
    align-items: center;

    &-wrapper {
      margin-left: 6px;
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    &-icon {
      color: $rfx-bright-blue;
      font-size: 24px;
    }

    &-label {
      margin-left: 5px;
      color: $rfx-bright-blue;
    }
  }

  &__container {
    min-width: 964px;
  }

  &__loader {
    display: flex;
    width: 100%;
    justify-content: center;
    height: calc(100vh - 530px);
    align-items: center;
  }

  &__update-loader {
    position: fixed;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    background-color: white;
    top: 0;
    left: 0;
    opacity: 0.5;
    z-index: 10000;
  }

  &__update-loader-ring {
    margin-top: 300px;
  }

  &__editor-container__wrapper {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    user-select: none;
  }

  &__editor-container__wrapper-drag {
    pointer-events: all !important;
  }

  &__editor-resize-disabled {
    &::v-deep .handle {
      pointer-events: none !important;
      cursor: default !important;
    }
  }

  &__resizing {
    .publishing-tab__editor {
      pointer-events: none !important;
      user-select: none !important;
    }
  }

  &__editor-container {
    background-color: #fff;
    box-shadow: 0 0 10px 27px rgba(0, 0, 0, 0.1);
    z-index: 999;
    pointer-events: all;

    &_shifted {
      width: 78vw;
      margin-left: 100px;
    }

    &::v-deep .handle {
      position: absolute;
      z-index: 1000;
      display: block !important;
    }

    &::v-deep .handle-tm {
      height: 6px;
      width: 98.6%;
      left: 6px;
      cursor: ns-resize;
    }

    &::v-deep .handle-bm {
      height: 6px;
      width: 98.6%;
      left: 6px;
      cursor: ns-resize;
      bottom: 0;
    }

    &::v-deep .handle-tl {
      height: 12px;
      width: 6px;
      cursor: nwse-resize;
    }

    &::v-deep .handle-bl {
      height: 12px;
      width: 6px;
      cursor: nesw-resize;
      bottom: 0;
    }

    &::v-deep .handle-tr {
      right: 0;
      height: 12px;
      width: 6px;
      cursor: nesw-resize;
    }

    &::v-deep .handle-br {
      right: 0;
      height: 12px;
      width: 6px;
      bottom: 0;
      cursor: nwse-resize;
    }

    &::v-deep .handle-ml,
    .handle-mr {
      top: 12px;
      height: 95.2%;
      width: 6px;
      cursor: ew-resize;
    }

    &::v-deep .handle-mr {
      right: 0;
    }
  }

  &__editor {
  }
  &__editor-drag {
    pointer-events: none;
    user-select: none;

    &::v-deep .content-notes-editor__wrapper {
      user-select: none !important;
    }
  }
  &__not-found {
    font-size: 27px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    color: $rfx-medium-grey;
  }
}

.publishing-tab__print {
  padding-bottom: 0;

  .container {
    width: calc(100% - 60px);
  }
}

@media print {
  @page {
    margin: 0;
    size: auto;
  }
}

input {
  //   width: 100%;
  //   height: 100%;

  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 25px;
  margin-left: 10px;
  border: 0;
  outline: none;

  width: 100%;
  box-sizing: border-box;
  padding-right: 60px;
  font-weight: 500;
  @include ellipsis;
}
</style>
